module.exports = __webpack_public_path__ + "static/media/karta.41c793ad.svg";